import { Component, Inject, OnInit, EventEmitter } from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE='cs_id_700';

const stepsList = [
  { text: "1", active: true, completed: false, tooltip: 'Acciones', listHelp: ['769'] },
 /*  { text: "2", active: false, completed: false, tooltip: 'Costo fiscal inmuebles exterior', listHelp: ['cas1', 'cas2'] },
  { text: "3", active: false, completed: false, tooltip: 'Datos inmuebles exterior', listHelp: ['cas1', 'cas2'] },
  { text: "4", active: false, completed: false, tooltip: 'Inmueble nacional', listHelp: ['cas1', 'cas2'] },
  { text: "5", active: false, completed: false, tooltip: 'Datos nacional', listHelp: ['cas1', 'cas2'] } */
];

const tableStructure = [
  {id: 'desc', title: 'Descripción'}, 
  {id: 'valVenta', title: 'Valor'}
  
];

class Form1 {
  id: number;
  desc: string;
  valCompra: string;
  anioCompra: number;
  valDeclaradoAnioAnterior: string;
  aplicoArt73:string;
  valAjustadoArt73: string;
  art: number;
  valDeclarar:string;
  valCostoFiscal:string;
  lugarCotizacion: number;
  lugarCotDesc:string;
  valVenta: string;
  valImpuestoPag: string;
  valImpuestoBVC: string;
  valImpuestoCol: string;
  limiteImpuesto: string;
}

class ArticulosDominio {
  valor: number;
  nombre: string;
}

@Component({
  selector: 'app-ganancias-ocasionales-acciones-modal',
  templateUrl: './ganancias-ocasionales-acciones-modal.component.html',
  styleUrls: ['./ganancias-ocasionales-acciones-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio
  ]
})
export class GananciasOcasionalesAccionesModalComponent extends HandlerModal implements OnInit {

  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public modelForm: Form1 = new Form1();
  public lstArticulos: ArticulosDominio[] = [];
  public lstLugarCotizacion: ArticulosDominio[] = [];
  public lstAnios: number[] = [];

  public OPERACION_NULA:number = 0;
  public OPERACION_AGREGAR:number = 1;
  public OPERACION_EDITAR:number = 2;
  public OPERACION_BORRAR:number = 3; 
  public operacionTabla:number = this.OPERACION_NULA;

  saveModel = new EventEmitter();
  public showSave:boolean; 0
  tablaArt73:any;

  constructor(
    public dutilidades:DOperacionesMatematicasServicio, 
    public dNotificacionServicio: DNotificacionServicio,
    public dialogRef: MatDialogRef<GananciasOcasionalesAccionesModalComponent>,
    @Inject(MAT_DIALOG_DATA) public model: DDocumento
  ) { 
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);

    console.log(model);
  }

  ngOnInit() {
    this.inicializeModelo();
    this.inicializeForm();
    this.initializeTablaDesdeModelo();
    this.validateShowSave();
    //this.reloadSelArticulos();
    this.initializeAnios();
    this.initializeLugarCotizacion();
  }

  protected inicializeForm(){
    this.modelForm = new Form1();
    this.modelForm.id=0;
    this.modelForm.desc="";
    this.modelForm.valCompra="0";
    this.modelForm.anioCompra=0;
    this.modelForm.valDeclaradoAnioAnterior="0";
    this.modelForm.aplicoArt73="1";
    this.modelForm.valAjustadoArt73="0";
    this.modelForm.art=0;
    this.modelForm.valDeclarar="0";
    this.modelForm.lugarCotizacion=0;
    this.modelForm.valVenta="0";
    this.modelForm.valImpuestoPag="0";
    this.modelForm.valImpuestoBVC="0";
    this.modelForm.valImpuestoCol="0";
    this.modelForm.limiteImpuesto="0";
    this.modelForm.valCostoFiscal="0";
    this.reloadSelArticulos();
  }
  
  protected inicializeModelo(){
    if(this.model.doc.cuerpo.cc_id_221 == undefined
    || this.model.doc.cuerpo.cc_id_221.length == 0){
        this.model.doc.cuerpo.cc_id_221 = [];
        this.model.doc.cuerpo.cc_id_191 = [];
        this.model.doc.cuerpo.cc_id_190 = [];
        this.model.doc.cuerpo.cc_id_192 = [];
        this.model.doc.cuerpo.cc_id_194 = [];        
        this.model.doc.cuerpo.cc_id_222 = [];
        this.model.doc.cuerpo.cc_id_195 = [];
        this.model.doc.cuerpo.cc_id_196 = [];
        this.model.doc.cuerpo.cc_id_197 = [];
        this.model.doc.cuerpo.cc_id_189 = [];
        this.model.doc.cuerpo.cc_id_198 = [];
        this.model.doc.cuerpo.cc_id_423 = [];
        this.model.doc.cuerpo.cc_id_790 = [];
        this.model.doc.cuerpo.cc_id_199 = [];
        this.model.doc.cuerpo.cs_id_768 = "0";
        this.model.doc.cuerpo.cs_id_769 = "0";
        this.model.doc.cuerpo.cs_id_791 = "0";
        this.model.doc.cuerpo.cs_id_788 = "0";
        this.model.doc.cuerpo.cs_id_700="0";//Indicador de Completo
    }  
  }

  protected initializeLugarCotizacion(){
    this.lstLugarCotizacion[0] = {valor:0,nombre:"BVC"};
    this.lstLugarCotizacion[1] = {valor:1,nombre:"Exterior"};
    this.lstLugarCotizacion[2] = {valor:2,nombre:"Colombia / Otro"};
  }

  protected reloadSelArticulos(conservarArt?:boolean){//Dom 1649
    
    this.lstArticulos[0] = {valor:0,nombre:""};
    this.lstArticulos[1] = {valor:2,nombre:"Valor Compra"};
    this.lstArticulos[2] = {valor:3,nombre:"Valor declarado año anterior"};
    this.lstArticulos[3] = {valor:4,nombre:"Valor ajustado art. 70"};
    this.lstArticulos[4] = {valor:5,nombre:"Valor ajustado art. 73"};

    this.lstArticulos = [];
    let i=0;
    this.lstArticulos[i] = {valor:0,nombre:""};
    if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.modelForm.valCompra.toString(), "0")){
      i++;
      this.lstArticulos[i] = {valor:2,nombre:("Valor de Compra: $"+this.modelForm.valCompra)};
    }
    if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.modelForm.valDeclaradoAnioAnterior.toString(), "0")){
      i++;
      this.lstArticulos[i] = {valor:3,nombre:("Valor declarado 2021: $"+this.modelForm.valDeclaradoAnioAnterior)};
    }
    
    if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.modelForm.valAjustadoArt73.toString(), "0")){
      i++;
      this.lstArticulos[i] = {valor:5,nombre:("Valor ajustado art. 73: $"+this.modelForm.valAjustadoArt73)};
    }
    
    if(!conservarArt)this.modelForm.art=0;
  }

  protected initializeAnios(){
    for(let i=0; i<this.tablaArt73.length;i++){
      if( Number(this.tablaArt73[i].anio) != 2020 &&
         Number(this.tablaArt73[i].anio) != 2021 && Number(this.tablaArt73[i].anio) != 2022 
      ){
      this.lstAnios[i]=Number(this.tablaArt73[i].anio);
      }
    }
  }

  public operacionCs768(){
    let suma = "0"; //Val Costo Fiscal
    let suma2 = "0";//impuesto de BBV
    let suma3 = "0";//impuesto limite pagado en el exterior por venta de acciones
    let suma4 = "0";//suma de valVenta
    for(let i=0; i<this.dataSourceBody.length; i++){
      suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.dataSourceBody[i].valDeclarar, suma);
      suma2 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.dataSourceBody[i].valImpuestoBVC, suma2);
      suma3 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.dataSourceBody[i].limiteImpuesto, suma3);
      suma4 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.dataSourceBody[i].valVenta, suma4);
   
    }
    this.model.doc.cuerpo.cs_id_769 = suma;
    this.model.doc.cuerpo.cs_id_788 = suma2;
    this.model.doc.cuerpo.cs_id_791 = suma3; //impuesto total pagado en el exterior
    this.model.doc.cuerpo.cs_id_768 = suma4;
  }

  public operaciones(numCas?:number,soloEstaCasilla?:boolean):void {
    switch (numCas) {
      case 158:
        this.operacionCS158();
        break;
      
    }
    if(soloEstaCasilla)return;

    //Operaciones
    let resultado = "0";

    this.reloadSelArticulos();

  }
  
  operacionCS158(){
    this.model.doc.cuerpo.cs_id_158 = this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_158,true);
  }

  
  //////////////////////

  protected initializeTablaDesdeModelo(){
    this.dataSourceBody = [];
    for(let i=0; i<this.model.doc.cuerpo.cc_id_221.length; i++){
      this.modelForm.id=i;
      this.modelForm.desc=this.model.doc.cuerpo.cc_id_221[i].v;
      this.modelForm.valCompra=this.model.doc.cuerpo.cc_id_191[i].v;
      this.modelForm.anioCompra=this.model.doc.cuerpo.cc_id_190[i].v;
      this.modelForm.valDeclaradoAnioAnterior=this.model.doc.cuerpo.cc_id_192[i].v;
      this.modelForm.aplicoArt73=this.model.doc.cuerpo.cc_id_194[i].v;
      this.modelForm.valAjustadoArt73=this.model.doc.cuerpo.cc_id_195[i].v;      
      this.modelForm.art=this.model.doc.cuerpo.cc_id_222[i].v;
      this.modelForm.valDeclarar=this.model.doc.cuerpo.cc_id_196[i].v;
      this.modelForm.valCostoFiscal=this.model.doc.cuerpo.cc_id_196[i].v;
      this.modelForm.lugarCotizacion=this.model.doc.cuerpo.cc_id_197[i].v;
      this.modelForm.valVenta=this.model.doc.cuerpo.cc_id_189[i].v;
      this.modelForm.valImpuestoPag = this.model.doc.cuerpo.cc_id_198[i].v;
      this.modelForm.valImpuestoBVC = this.model.doc.cuerpo.cc_id_423[i].v;
      this.modelForm.valImpuestoCol = this.model.doc.cuerpo.cc_id_790[i].v;
      this.modelForm.limiteImpuesto=this.model.doc.cuerpo.cc_id_199[i].v;

      this.dataSourceBody.push(this.modelForm);
      
      this.inicializeForm();
    }
  }

  public editModeloDesdeForm(){
    this.model.doc.cuerpo.cc_id_221[this.modelForm.id].v=this.modelForm.desc;
    this.model.doc.cuerpo.cc_id_191[this.modelForm.id].v=this.modelForm.valCompra.toString();
    this.model.doc.cuerpo.cc_id_190[this.modelForm.id].v=this.modelForm.anioCompra.toString();
    this.model.doc.cuerpo.cc_id_192[this.modelForm.id].v=this.modelForm.valDeclaradoAnioAnterior.toString();
    this.model.doc.cuerpo.cc_id_194[this.modelForm.id].v=this.modelForm.aplicoArt73.toString();
    this.model.doc.cuerpo.cc_id_195[this.modelForm.id].v=this.modelForm.valAjustadoArt73.toString();
    this.model.doc.cuerpo.cc_id_222[this.modelForm.id].v=this.modelForm.art.toString();
    //this.model.doc.cuerpo.cc_id_423[this.modelForm.id].v=this.modelForm.valDeclarar;
    this.model.doc.cuerpo.cc_id_196[this.modelForm.id].v=this.modelForm.valCostoFiscal;
    this.model.doc.cuerpo.cc_id_197[this.modelForm.id].v = this.modelForm.lugarCotizacion.toString();
    this.model.doc.cuerpo.cc_id_189[this.modelForm.id].v = this.modelForm.valVenta;
    this.model.doc.cuerpo.cc_id_198[this.modelForm.id].v = this.modelForm.valImpuestoPag;
    this.model.doc.cuerpo.cc_id_423[this.modelForm.id].v = this.modelForm.valImpuestoBVC;
    this.model.doc.cuerpo.cc_id_790[this.modelForm.id].v = this.modelForm.valImpuestoCol;
    this.model.doc.cuerpo.cc_id_199[this.modelForm.id].v=this.modelForm.limiteImpuesto;


  }

  public addToModeloDesdeForm(){
    let i=this.modelForm.id+1;
    this.model.doc.cuerpo.cc_id_221.push({it: i, v:this.modelForm.desc});
    this.model.doc.cuerpo.cc_id_191.push({it: i, v:this.modelForm.valCompra.toString()});
    this.model.doc.cuerpo.cc_id_190.push({it: i, v:this.modelForm.anioCompra.toString()});
    this.model.doc.cuerpo.cc_id_192.push({it: i, v:this.modelForm.valDeclaradoAnioAnterior.toString()});
    this.model.doc.cuerpo.cc_id_194.push({it: i, v:this.modelForm.aplicoArt73.toString()});
    this.model.doc.cuerpo.cc_id_195.push({it: i, v:this.modelForm.valAjustadoArt73.toString()});
    this.model.doc.cuerpo.cc_id_222.push({it: i, v:this.modelForm.art.toString()});
    //this.model.doc.cuerpo.cc_id_423.push({it: i, v:this.modelForm.valDeclarar});
    this.model.doc.cuerpo.cc_id_196.push({ it: i, v: this.modelForm.valCostoFiscal });
    this.model.doc.cuerpo.cc_id_197.push({ it: i, v: this.modelForm.lugarCotizacion.toString() });
    this.model.doc.cuerpo.cc_id_189.push({ it: i, v: this.modelForm.valVenta });
    this.model.doc.cuerpo.cc_id_198.push({ it: i, v: this.modelForm.valImpuestoPag });
    this.model.doc.cuerpo.cc_id_423.push({ it: i, v: this.modelForm.valImpuestoBVC });
    this.model.doc.cuerpo.cc_id_790.push({ it: i, v: this.modelForm.valImpuestoCol });
    this.model.doc.cuerpo.cc_id_199.push({it: i, v:this.modelForm.limiteImpuesto});

  }

  public deleteOnModel(index:number){
    this.model.doc.cuerpo.cc_id_221.splice(index,1);
    this.model.doc.cuerpo.cc_id_191.splice(index,1);
    this.model.doc.cuerpo.cc_id_190.splice(index,1);
    this.model.doc.cuerpo.cc_id_192.splice(index,1);
    this.model.doc.cuerpo.cc_id_194.splice(index,1);
    this.model.doc.cuerpo.cc_id_195.splice(index,1);
    this.model.doc.cuerpo.cc_id_222.splice(index,1);
   // this.model.doc.cuerpo.cc_id_423.splice(index,1);
    this.model.doc.cuerpo.cc_id_196.splice(index,1);
    this.model.doc.cuerpo.cc_id_197.splice(index, 1);
    this.model.doc.cuerpo.cc_id_189.splice(index, 1);
    this.model.doc.cuerpo.cc_id_198.splice(index, 1);
    this.model.doc.cuerpo.cc_id_423.splice(index, 1);
    this.model.doc.cuerpo.cc_id_790.splice(index, 1);
    this.model.doc.cuerpo.cc_id_199.splice(index, 1);


    //reenumerear it
    for(let i=0;i<this.model.doc.cuerpo.cc_id_221.length;i++){
      this.model.doc.cuerpo.cc_id_221[i].it=i+1;
      this.model.doc.cuerpo.cc_id_191[i].it=i+1;
      this.model.doc.cuerpo.cc_id_190[i].it=i+1;
      this.model.doc.cuerpo.cc_id_192[i].it=i+1;
      this.model.doc.cuerpo.cc_id_194[i].it=i+1;
      this.model.doc.cuerpo.cc_id_195[i].it=i+1;
      this.model.doc.cuerpo.cc_id_222[i].it=i+1;
      //this.model.doc.cuerpo.cc_id_423[i].it=i+1;
      this.model.doc.cuerpo.cc_id_196[i].it=i+1;
      this.model.doc.cuerpo.cc_id_197[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_189[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_198[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_423[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_790[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_199[i].it = i + 1;
    }
  }

  public validateFormCompleted():boolean{
    return this.modelForm.desc==undefined || this.modelForm.desc==null || this.modelForm.desc.trim()=="" ||
        this.modelForm.valCompra==undefined || this.modelForm.valCompra=="0" || 
        this.modelForm.anioCompra==undefined || this.modelForm.anioCompra==0 ||
        this.modelForm.valDeclaradoAnioAnterior==undefined || 
        this.modelForm.art==undefined || this.modelForm.art==0 ||
        this.modelForm.aplicoArt73==undefined || this.modelForm.aplicoArt73==null
         ;
  }

  public redondearFormData(){
    this.modelForm.valCompra=this.dutilidades.redondearValorMoneda(this.modelForm.valCompra.toString(),true);
    this.modelForm.valDeclaradoAnioAnterior=this.dutilidades.redondearValorMoneda(this.modelForm.valDeclaradoAnioAnterior.toString(),true);
    this.modelForm.valVenta=this.dutilidades.redondearValorMoneda(this.modelForm.valVenta.toString(),true);
    this.modelForm.valImpuestoPag =this.dutilidades.redondearValorMoneda(this.modelForm.valImpuestoPag.toString(),true);
   
  }

  public calcularValoresForm(conservarArt?:boolean){
  
    this.redondearFormData();
    if(this.modelForm.lugarCotizacion!= 1){
      this.modelForm.valImpuestoCol = "0";
      this.modelForm.valImpuestoPag = "0";
      this.modelForm.limiteImpuesto = "0";
    }
    if(this.modelForm.lugarCotizacion!= 0){
      this.modelForm.valImpuestoBVC = "0";
     
    }

    if(this.modelForm.aplicoArt73=="1" &&   this.modelForm.anioCompra  != undefined &&  this.modelForm.anioCompra > 0){
      let registroArt73 = this.tablaArt73.find((ite: any) => this.modelForm.anioCompra == ite.anio);
      let resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,this.modelForm.valCompra.toString(), registroArt73.acciones.toString(),false);
      this.modelForm.valAjustadoArt73 = resultado;
      this.modelForm.valAjustadoArt73 = this.dutilidades.redondearValorMoneda(this.modelForm.valAjustadoArt73.toString(),true);
      console.log(registroArt73);
    }else{
      this.modelForm.valAjustadoArt73 = "0";
    }
    this.modelForm.valAjustadoArt73 = this.dutilidades.redondearValorMoneda(this.modelForm.valAjustadoArt73.toString(),true);
    
    switch(Number(this.modelForm.art)){
      case 1:
        //Nada
        break;
      case 2:
        this.modelForm.valDeclarar = this.modelForm.valCompra.toString();
        break;
      case 3:
        this.modelForm.valDeclarar = this.modelForm.valDeclaradoAnioAnterior.toString();
        break;
      case 5:
        this.modelForm.valDeclarar = this.modelForm.valAjustadoArt73.toString();
        break;  
      default:
        this.modelForm.valDeclarar = "0";      
    }
    
    
    this.modelForm.valDeclarar = this.dutilidades.redondearValorMoneda(this.modelForm.valDeclarar.toString(),true);
     //accion de BVC?
    let resultado = "0";
    resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA,this.modelForm.valVenta,this.modelForm.valDeclarar);
    console.log("resultado="+resultado);
    if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE,resultado,"0")){

      if (Number(this.modelForm.lugarCotizacion) == 0 ){//BVC
        this.modelForm.valImpuestoBVC = resultado;  //Si acción es BVC la suma
        this.modelForm.valImpuestoBVC = this.dutilidades.redondearValorMoneda(this.modelForm.valImpuestoBVC.toString(),true);
      }else{
        this.modelForm.valImpuestoBVC ="0";
      }

      if (Number(this.modelForm.lugarCotizacion) == 1 ){//Exterior
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, this.modelForm.valImpuestoPag,"0")){
          resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,resultado,"0.10");
          this.modelForm.valImpuestoCol = resultado;
          if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, this.modelForm.valImpuestoPag,this.modelForm.valImpuestoCol)){
            this.modelForm.limiteImpuesto = this.modelForm.valImpuestoPag;
          }else{
            this.modelForm.limiteImpuesto = this.modelForm.valImpuestoCol;    
          }
          this.modelForm.limiteImpuesto = this.dutilidades.redondearValorMoneda(this.modelForm.limiteImpuesto.toString(),true);
        }
      }else{
          this.modelForm.valImpuestoCol = "0";
          this.modelForm.limiteImpuesto = "0";
      }
    }else{
      this.modelForm.valImpuestoBVC ="0";
      this.modelForm.valImpuestoCol = "0";
      this.modelForm.limiteImpuesto = "0";
    }
    this.modelForm.valCostoFiscal = this.modelForm.valDeclarar;
    this.reloadSelArticulos(conservarArt);
  }

  saveItem(): void {
    if(this.validateFormCompleted()){
      let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro" );
      return;
    }else{
      this.redondearFormData();
      if (this.operacionTabla==this.OPERACION_EDITAR){
        this.editModeloDesdeForm();
      }else if (this.operacionTabla==this.OPERACION_AGREGAR){
        this.modelForm.id = this.dataSourceBody.length;
        this.dataSourceBody.push(this.modelForm);
        this.addToModeloDesdeForm();
      }
      //Recalcular y reinicializar
      this.operacionCs768();
      this.inicializeForm();
      this.operacionTabla=this.OPERACION_NULA;
      console.log(this.model);
    }
  }

  eventTable($event: string): void {
    if($event === 'add') this.operacionTabla=this.OPERACION_AGREGAR;
    if($event === 'edit') this.operacionTabla=this.OPERACION_EDITAR;
    if($event === 'delete') this.operacionTabla=this.OPERACION_BORRAR;
    this.operacionCs768();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if(this.operacionTabla==this.OPERACION_EDITAR){//editando
      this.modelForm = this.dataSourceBody[index];
      this.reloadSelArticulos(true);
    }
    if(this.operacionTabla==this.OPERACION_BORRAR){//borrando
      this.deleteOnModel(index);
      this.operacionTabla=this.OPERACION_NULA;
      console.log(this.model);
    }
  }
  
  cancel(): void {
    this.inicializeForm();
    this.operacionTabla=this.OPERACION_NULA;
  }

  
  ///////////////////////

  //Aplica si dentro del modal hay preguntas SI/NO
  public validateRbQuestions(val: string) {
    this.modelForm.aplicoArt73 = val;
    this.calcularValoresForm();
  }
  
  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion:number): boolean{
    let hasValues:boolean = false;
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal:number){
    
  }
  
  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateStepHabilitado(indexS:number):boolean{
    let habilitado = true;
    return habilitado;
  }

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateBtnRightActive(){

  }

  //////////////////////////
  
  protected obtenerCasIndicadorAvance():string{
    if(this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==undefined){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]="0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }
  protected updateIndicadorAvance(){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(this.indexStepper> Number(casIndicadorAvance)){
      let indexS = this.indexStepper+1;
      while(!this.validateStepHabilitado(indexS)){
        indexS++;
      }
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=indexS.toString();
    }
    if(this.indexStepper==this.stepsList.length-1){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=VAL_INDICADOR_COMPLETO;
    }
  }


  protected controlStep(direction: DirectionType): void {
    this.changeStepLocal(this.indexStepper, true);
  }

  public changeStepLocal(index: number, forceUpdateStepper?:boolean){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(forceUpdateStepper){
      this.changeStep(index);
      this.updateIndicadorAvance();
    }else if(this.validateStepHabilitado(index)){
      let indexCalc = index-1;
      if(indexCalc<=Number(casIndicadorAvance)){
        this.changeStep(index);
        this.updateIndicadorAvance();
      }else{
        console.log("Avance no permitido: casIndicadorAvance=" + casIndicadorAvance + ", index-1="+(indexCalc));
      }
    }
    this.validateBtnRightActive();
    this.validateShowSave();
  }
  
  protected validateShowSave(){
    if(this.indexStepper==this.stepsList.length-1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==VAL_INDICADOR_COMPLETO){ this.showSave=true };
  }

  public closeModal(){
    this.changeStepLocal(0);
    this.dialogRef.close("");
  }
  public guardar(){
    this.saveModel.emit(true);
    if(this.indexStepper==this.stepsList.length-1){
      this.closeModal();
    }
  }
  public borrarTabla(){
    this.dataSourceBody = [];
  }

}




// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/ganancias-ocasionales/ganancias-ocasionales-acciones-modal/ganancias-ocasionales-acciones-modal.component.ts